module.exports = __webpack_public_path__ + "img/113.511a1871.jpg";